var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_WeakMap.js
// module id = 686
// module chunks = 168707334958949